var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "signIn" },
    [
      _c("h1", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("common.signIn"))),
      ]),
      _vm._v(" "),
      _c("eb-sign-in-form"),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "mt-3" },
        [
          _c("router-link", { attrs: { to: "/password-reset" } }, [
            _vm._v(_vm._s(_vm.$t("msg.ForgotPassword"))),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "mt-5" },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.$t(`msg["You don't have an account?"]`)) +
              " \n    "
          ),
          _c("router-link", { attrs: { to: "/signup" } }, [
            _vm._v(_vm._s(_vm.$t('msg["create account now!!"]'))),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }